<form [formGroup]="productForm" novalidate action="javascript:void(0);">
  <div class="container bg-white border-secondary border-primary">
    <div class="form-row">
      <div class="col-md-12 mb-4">
        <label for="title" translate>Title</label>
        <input [ngClass]="{'is-invalid': submitted && f.title.errors }" type="text" formControlName="title" class="form-control" id="title" placeholder="{{'Title' | translate}}">
        <div *ngIf="submitted && f.title.errors && f.title.errors.required" class="invalid-feedback" translate>
          Required field
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-12 mb-4 form-group">
        <label for="description" translate>Description</label>
        <textarea formControlName="description" class="form-control" id="description" rows="3"></textarea>
      </div>
    </div>
  </div>
  <div class="container bg-white border-secondary border-primary">
    <div class="form-row">
      <div class="col-md-6 mb-4">
        <label for="price" translate>Price</label>
        <input [ngClass]="{'is-invalid' : submitted && f.price.errors}" type="text" formControlName="price" class="form-control" id="price" placeholder="{{'Price' | translate}}">
        <div *ngIf="submitted && f.price.errors && f.price.errors.required" class="invalid-feedback" translate>
          Required field
        </div>
        <div *ngIf="submitted && f.price.errors && f.price.errors.pattern" class="invalid-feedback" translate>
          Invalid value
        </div>
      </div>
      <div class="col-md-6 mb-4">
        <label for="qty" translate>Qty</label>
        <input [ngClass]="{'is-invalid' : submitted && f.qty.errors}" formControlName="qty" type="text" class="form-control" id="qty" placeholder="{{'Qty' | translate}}">
        <div *ngIf="submitted && f.qty.errors && f.qty.errors.required" class="invalid-feedback" translate>
          Required field
        </div>
        <div *ngIf="submitted && f.qty.errors && f.qty.errors.pattern" class="invalid-feedback" translate>
          Invalid value
        </div>
      </div>
    </div>
  </div>
<!--  <div class="container bg-white border-secondary shadow border-primary">-->
<!--    <div class="form-row">-->
<!--      <div class="col-md-12 mb-2 form-group border-danger border-width-3px">-->
<!--        <div class="custom-file-container" data-upload-id="mainProductImage">-->
<!--          <label>{{ 'Main Product Image' | translate }} <span style="font-size: 7pt">(1600px X 900px)</span>-->
<!--            <a href="javascript:void(0)" class="custom-file-container__image-clear" title="Clear Image">x</a>-->
<!--          </label>-->
<!--          <label class="custom-file-container__custom-file">-->
<!--            <input type="file" class="custom-file-container__custom-file__custom-file-input" accept="image/*">-->
<!--            <input type="hidden" name="MAX_FILE_SIZE" value="2097152"/>-->
<!--            <span class="custom-file-container__custom-file__custom-file-control"></span>-->
<!--          </label>-->
<!--          <pintura-editor #mainProductEditor *ngIf="productMainUrl.value != null" [src]="productMainUrl.value"-->
<!--                          [options]="productMainPinturaOptions" [imageCropAspectRatio]="16 / 9" (load)="imageLoaded($event)"-->
<!--          ></pintura-editor>-->
<!--          <div *ngIf="loadingMainPictures.value" class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>-->
<!--          <div [hidden]="loadingMainPictures.value || productMainUrl.value != null" class="custom-file-container__image-preview"></div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="form-row">-->
<!--      <div class="col-md-12 mb-2 form-group border-danger border-width-3px">-->
<!--        <div class="custom-file-container" data-upload-id="thumbnailProductImage">-->
<!--          <label>{{ 'Thumbnail Product Image' | translate }} <span style="font-size: 7pt">(300px X 300px)</span><a href="javascript:void(0)" class="custom-file-container__image-clear" title="Clear Image">x</a></label>-->
<!--          <label class="custom-file-container__custom-file" [hidden]="true">-->
<!--            <input type="file" class="custom-file-container__custom-file__custom-file-input" accept="image/*">-->
<!--            <input type="hidden" name="MAX_FILE_SIZE" value="2097152"/>-->
<!--            <span class="custom-file-container__custom-file__custom-file-control"></span>-->
<!--          </label>-->
<!--          <pintura-editor #thumbnailProductEditor *ngIf="productThumbnailUrl.value != null" [src]="productThumbnailUrl.value"-->
<!--                          [options]="productThumbnailPinturaOptions" [imageCropAspectRatio]="1"-->
<!--                          (process)="handleEditorProcess($event)">-->
<!--          </pintura-editor>-->
<!--          <div *ngIf="loadingThumbnailPictures.value" class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>-->
<!--          <div [hidden]="loadingThumbnailPictures.value || productThumbnailUrl.value" class="custom-file-container__image-preview"></div>-->
<!--          &lt;!&ndash;          <div *ngIf="thumbnailPictureHeight && thumbnailPictureWidth && (thumbnailPictureHeight != 300 || thumbnailPictureWidth != 300)" class="text-danger" translate>The picture size is not 300x300 pixels. Therefore, it may not be displayed appropriately to clients.</div>&ndash;&gt;-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="form-row">-->
<!--      <div class="col-md-12 mb-2 form-group border-danger border-width-3px">-->
<!--        <div class="custom-file-container" data-upload-id="gridProductImage">-->
<!--          <label>{{ 'Grid Product Image' | translate }} <span style="font-size: 7pt">(1200px X 1200px)</span><a href="javascript:void(0)" class="custom-file-container__image-clear" title="Clear Image">x</a></label>-->
<!--          <label class="custom-file-container__custom-file" [hidden]="true">-->
<!--            <input type="file" class="custom-file-container__custom-file__custom-file-input" accept="image/*">-->
<!--            <input type="hidden" name="MAX_FILE_SIZE" value="2097152"/>-->
<!--            <span class="custom-file-container__custom-file__custom-file-control"></span>-->
<!--          </label>-->
<!--          <pintura-editor #gridProductEditor *ngIf="productGridUrl.value" [src]="productGridUrl.value"-->
<!--                          [options]="productGridPinturaOptions" [imageCropAspectRatio]="1"-->
<!--                          (process)="handleEditorProcess($event)"></pintura-editor>-->
<!--          <div *ngIf="loadingGridPictures.value" class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>-->
<!--          <div [hidden]="loadingGridPictures.value || productGridUrl.value" class="custom-file-container__image-preview"></div>-->
<!--          &lt;!&ndash;          <div *ngIf="gridPictureHeight && gridPictureWidth && (gridPictureHeight != 1200 || gridPictureWidth != 1200)" class="text-danger" translate>The picture size is not 1200x1200 pixels. Therefore, it may not be displayed appropriately to clients.</div>&ndash;&gt;-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
  <div class="container bg-white border-secondary border-primary">
    <button class="btn btn-primary" type="submit" (click)="submitForm()" translate>Submit</button>&nbsp;
    <button class="btn btn-light-danger" (click)="closeModal()" translate>Close</button>
  </div>
</form>
